import React, { useState, useEffect, useMemo ,useRef} from "react";
import {
  FaCalendarAlt,
  FaHourglassHalf,
  FaUser,
  FaChevronDown,
  FaInfoCircle,
  FaTrash,
} from "react-icons/fa";
import { TbRepeat } from "react-icons/tb";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "../../../context/CartContext";
import { useSelector } from "react-redux";
import PhoneModel from "../../components/PhoneModel";
import { PetDrawer } from "../../../components/PetDrawer/PetDrawer";
import { Customerdetaildrawer } from "../../../components/Customerdetaildrawer/Customerdetaildrawer";
import { SecondaryUserDrawer } from "../../../components/Customerdetaildrawer/SecondaryUserDrawer"; //new
import Select from "react-select";
import { useProfile } from "../../../context/ProfileContext";
import config from "../../../config";


const Tooltip = ({ discounts = [] }) => {
  const activeDiscounts = discounts.filter(
    (d) => Number(d.is_active) === 1
  );

  return (
    <span className="group relative cursor-pointer ml-1 inline-block">
      <span className="text-gray-400 hover:text-gray-600 transition-colors">
        <FaInfoCircle size={16} />
      </span>

      <div
        className="absolute top-full right-0 mt-2 w-56 
        invisible group-hover:visible opacity-0 group-hover:opacity-100 
        transition-all duration-300 z-[9999] pointer-events-none"
      >
        {/* Container */}
        <div className="bg-white border border-orange-100 shadow-xl rounded-xl p-3">
          {/* Header */}
          <div className="flex justify-center mb-1.5 pb-1 border-b border-orange-50">
            <span className="text-[10px] font-bold uppercase tracking-wider text-orange-500">
              Applied Discounts
            </span>
          </div>

          {/* Content */}
          {activeDiscounts.length > 0 ? (
            <ul className="space-y-1 text-[12px] text-[#000048] font-medium text-center">
              {activeDiscounts.map((d, i) => (
                <li key={i}>
                  {d.name.replace(/_/g, " ").toUpperCase()} —{" "}
                  {d.type === "percentage"
                    ? `${d.value}% OFF`
                    : `₹${d.discount_amount} OFF`}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-[12px] text-gray-500 text-center">
              No discount applied
            </p>
          )}
        </div>

        {/* Arrow */}
        <div className="absolute -top-1 right-[3px] w-2.5 h-2.5 bg-white border-t border-l border-orange-100 rotate-45"></div>
      </div>
    </span>
  );
};

const Confirm = () => {
  const navigate = useNavigate();
  const userPhone = useSelector((state) => state.auth.phone);
  const customerData = useSelector((state) => state.auth.customer_data);
  const { cartItems, setCartItems, vendorID, guestvendorid , removeFromCart } = useCart();
  const API_BASE_URL = config.API_BASE_URL;
   
  const { displayDetails, isSecondaryUser: isSecUser ,refetchCustomer} = useProfile();   //new
  const [customerDetails, setCustomerDetails] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [isPhoneModelOpen, setIsPhoneModelOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingPet, setEditingPet] = useState(null);
  const [pets, setPets] = useState([]);
  const [isCustomerDetailsOpen, setIsCustomerDetailsOpen] = useState(true);
  const [petTypes, setPetTypes] = useState([]);
  const [petBreeds, setPetBreeds] = useState([]);
  const [petSizes, setPetSizes] = useState([]);
  const [cartErrors, setCartErrors] = useState({});
  const [autoAssigned, setAutoAssigned] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [pendingPriceUpdate, setPendingPriceUpdate] = useState(null);
  const [isPriceLoading, setIsPriceLoading] = useState(false);
  const [loading, setLoading] = useState(true);
 
  const [sizesByVendor, setSizesByVendor] = useState({}); // { [vendorId]: { [petTypeId]: [sizeObj...] } }
  const [sizesLoading, setSizesLoading] = useState({}); // to avoid duplicate requests
  // Customer drawer
  const [isCustomerDrawerOpen, setIsCustomerDrawerOpen] = useState(false);
  const [isSecondaryDrawerOpen, setIsSecondaryDrawerOpen] = useState(false);   //new
  const [selectedSecondaryUser, setSelectedSecondaryUser] = useState(null);   //new
  const token = localStorage.getItem("token");
  const clientId = customerData?._id || customerData?.id;

  const toggleCustomerDetails = () => setIsCustomerDetailsOpen((prev) => !prev);
  const [isPetListOpen, setIsPetListOpen] = useState(true);
 // const [itemNotes, setItemNotes] = useState({});

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const { guestPetData, clearGuestPetData, user } = useCart();
  
  const [deleteItemId, setDeleteItemId] = useState(null);
  const itemToDelete = cartItems.find(
    (item) => (item.cartItemId || item._id) === deleteItemId
  );
  const [selectedGuestPet, setSelectedGuestPet] = useState(null);
   const [quickAddMode, setQuickAddMode] = useState(false);
  const [quickAddServiceIndex, setQuickAddServiceIndex] = useState(null);

   const auth = useSelector((state) => state.auth);
   const { secondaryUserInfo, isSecondaryUser: isSecUserFromAuth } = auth || {};
  
  // ------------------ FETCH DATA ------------------
  
// Helper: fetch sizes for vendor + pet type and cache them
const fetchVendorPetSizes = async (vendorId, petTypeId) => {
  if (!vendorId || !petTypeId) return [];
  // already cached?
  if (sizesByVendor[vendorId] && sizesByVendor[vendorId][petTypeId]) {
    return sizesByVendor[vendorId][petTypeId];
  }
  const key = `${vendorId}_${petTypeId}`;
  if (sizesLoading[key]) return []; // already fetching
  setSizesLoading((s) => ({ ...s, [key]: true }));

  try {
    const res = await axios.get(`${API_BASE_URL}/customer/getPetsizes/`, {
      params: { vendor_id: vendorId, pet_type: petTypeId },
    });
    const sizes = res.data?.status ? res.data.data || [] : [];
    setSizesByVendor((prev) => ({
      ...prev,
      [vendorId]: { ...(prev[vendorId] || {}), [petTypeId]: sizes },
    }));
    return sizes;
  } catch (err) {
    console.error("Failed to fetch vendor sizes", vendorId, petTypeId, err);
    setSizesByVendor((prev) => ({
      ...prev,
      [vendorId]: { ...(prev[vendorId] || {}), [petTypeId]: [] },
    }));
    return [];
  } finally {
    setSizesLoading((s) => ({ ...s, [key]: false }));
  }
};

// Prefetch sizes for all vendorId x pet_type combinations we care about
useEffect(() => {
  if (!cartItems || cartItems.length === 0 || !pets || pets.length === 0) return;

  const pairs = new Set();
  cartItems.forEach((item) => {
    const v = item.vendor_id || vendorID || guestvendorid;
    // If vendor not found skip
    if (!v) return;
    // We need to check every pet the user has (only those with pet_type)
    pets.forEach((pet) => {
      if (pet.pet_type) pairs.add(`${v}_${pet.pet_type}`);
    });
  });

  const toFetch = Array.from(pairs).map((k) => {
    const [v, t] = k.split("_");
    return fetchVendorPetSizes(v, t);
  });

  if (toFetch.length) {
    Promise.all(toFetch).catch((e) =>
      console.error("Batch fetch vendor sizes failed", e)
    );
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartItems, pets, vendorID, guestvendorid]);

// Matching helpers (reuse same normalization used on TimeSlot)
const isSizeSupportedForThisService = (pet, item) => {
  if (!pet || !pet.pet_type) return false;
  const v = item.vendor_id || vendorID || guestvendorid;
  if (!v) return false;
  const sizes = sizesByVendor[v]?.[pet.pet_type] || [];
  if (!sizes || sizes.length === 0) return false;

  // 1) Match by flps_pet_size_id or vendor size _id
  if (pet.size != null) {
    if (
      sizes.some(
        (s) =>
          String(s.flps_pet_size_id) === String(pet.size) ||
          String(s._id) === String(pet.size) ||
          String(s.id) === String(pet.size)
      )
    )
      return true;
  }

  // 2) Match by pet.size_label
  if (pet.size_label) {
    if (
      sizes.some(
        (s) =>
          String(s.size_label).toLowerCase() ===
          String(pet.size_label).toLowerCase()
      )
    )
      return true;
  }

  // 3) If pet.size is actually a label string
  if (typeof pet.size === "string") {
    if (
      sizes.some(
        (s) => String(s.size_label).toLowerCase() === pet.size.toLowerCase()
      )
    )
      return true;
  }

  // No match
  return false;
};

// Return matched vendor size id (prefer flps_pet_size_id), or null
const getMatchedSizeId = (pet, item) => {
  if (!pet || !pet.pet_type) return null;
  const v = item.vendor_id || vendorID || guestvendorid;
  if (!v) return null;
  const sizes = sizesByVendor[v]?.[pet.pet_type] || [];
  if (!sizes || sizes.length === 0) return null;

  // Try id matches first
  let found =
    sizes.find((s) => String(s.flps_pet_size_id) === String(pet.size)) ||
    sizes.find((s) => String(s._id) === String(pet.size)) ||
    sizes.find((s) => String(s.id) === String(pet.size));

  if (found) return found.flps_pet_size_id || found._id || found.id;

  // Try label match
  if (pet.size_label) {
    found = sizes.find(
      (s) => String(s.size_label).toLowerCase() === pet.size_label.toLowerCase()
    );
    if (found) return found.flps_pet_size_id || found._id || found.id;
  }

  // Try when pet.size is a label string
  if (typeof pet.size === "string") {
    found = sizes.find(
      (s) => String(s.size_label).toLowerCase() === pet.size.toLowerCase()
    );
    if (found) return found.flps_pet_size_id || found._id || found.id;
  }

  return null;
};

    const getAllowedPetTypeIdsForItem = (item) => {
  
  if (item.allowedPetTypes && Array.isArray(item.allowedPetTypes)) {
    return item.allowedPetTypes.map(pt => pt.id || pt.pet_type_id || pt._id);
  }
  
  // If you didn't store it → worst case you can refetch, but better to store when adding to cart
  return [];
};

//  Check if a pet is allowed for this specific cart item
  const isPetAllowedForThisService = (pet, item) => {
    if (!pet?.pet_type) return false;
    
    const allowedIds = getAllowedPetTypeIdsForItem(item);
    if (allowedIds.length === 0) return true; // if no restriction → allow all (safety fallback)
    
    return allowedIds.includes(pet.pet_type);
  };

const isPetFullyCompatible = (pet, item) => {
  // Step 1: Check pet type (you already have this function)
  if (!isPetAllowedForThisService(pet, item)) {
    return false;
  }

  // Step 2: Basic safety checks
  if (!pet?.pet_type) return false;

  const vendorId = item.vendor_id || vendorID || guestvendorid;
  if (!vendorId) return false;

  // Step 3: Get vendor's allowed sizes for this pet type
  const vendorSizes = sizesByVendor[vendorId]?.[pet.pet_type] || [];

  // If sizes haven't loaded yet → allow temporarily (safety net)
  if (vendorSizes.length === 0) {
    return true;
    //return false;
  }
  // Step 4: Check if pet's size matches any allowed vendor size
  return vendorSizes.some((s) => {
    // Match by ID (most reliable)
    if (
      String(s.flps_pet_size_id) === String(pet.size) ||
      String(s._id) === String(pet.size) ||
      String(s.id) === String(pet.size)
    ) {
      return true;
    }

    // Match by size_label if pet has it
    if (pet.size_label) {
      if (String(s.size_label).toLowerCase() === String(pet.size_label).toLowerCase()) {
        return true;
      }
    }

    // Match when pet.size itself is a string label
    if (typeof pet.size === "string") {
      if (String(s.size_label).toLowerCase() === pet.size.toLowerCase()) {
        return true;
      }
    }

    return false;
  });
};
  const fetchCustomerDetails = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/customer/getcustomerdetails`,
        {
          params: { customer_id: clientId },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.data?.success) setCustomerDetails(res.data.data);
      else toast.error(res.data?.message || "Failed to fetch customer details");
    } catch {
      toast.error("Error fetching customer details");
    }
  };

  const fetchPetTypes = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/customer/customerpettype`
      );
      if (res.data?.status) setPetTypes(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBreeds = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/customer/customerbreed`
      );
      if (res.data?.status) setPetBreeds(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSizes = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/customer/getPetsizes`
      );
      if (res.data?.status) setPetSizes(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchPets = async () => {
    if (!clientId) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/customer/getallpet`,
        { client_id: clientId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPets(response.data?.pets || []);
    } catch {
      toast.error("Failed to fetch pets");
    }
  };

  // ✅ Fetch service price based on selected pet
const fetchServicePrice = async (service_type, baseData) => {
  try {
    if (!service_type || !baseData) return 0;

    const type = service_type.toLowerCase().trim();

    // Normalize service type
    let normalizedType = "";
    if (type.includes("boarding") || type.includes("resort"))
      normalizedType = "boarding";
    else if (type.includes("grooming")) normalizedType = "grooming";
    else if (type.includes("mobile"))
      normalizedType = "mobile pet grooming van";
    else if (type.includes("home")) normalizedType = "home grooming";
    else if (type.includes("day")) normalizedType = "day_care";
    else if (type.includes("walk")) normalizedType = "dog_walking";
    else if (type.includes("vet")) normalizedType = "vet_clinic";
    else normalizedType = "grooming"; // fallback

    let payload = {};

    // Build payload based on normalized service type
    switch (normalizedType) {
      case "grooming":
      case "home grooming":
      case "mobile pet grooming van":
      case "vet_clinic":
        payload = {
          vendor_id: baseData.vendor_id,
          client_id: baseData.client_id,
          pet_id: baseData.pet_id,
          service_id: baseData.vendor_service_id || baseData.service_id,
          pet_size: baseData.petSize || 0,
          pet_breed: baseData.petBreed || 0,
          service_type: normalizedType,
        };
        break;

      case "boarding":
        payload = {
          vendor_id: baseData.vendor_id,
          client_id: baseData.client_id,
          pet_id: baseData.pet_id,
          service_type: "boarding",
          service_id:
            baseData.service_id ||
            baseData.room_service_id ||
            baseData.vendor_service_id,
          room_type_id: baseData.room_type_id,
          pet_size: baseData.petSize || 0,
          pet_breed: baseData.petBreed || 0,
          checkin_date: baseData.checkin_date,
          checkout_date: baseData.checkout_date,
        };
        break;

      case "day_care":
        payload = {
          vendor_id: baseData.vendor_id,
          client_id: baseData.client_id, // ✅ FIXED: Added client_id
          pet_id: baseData.pet_id, // ✅ FIXED: Added pet_id
          service_type: "day_care",
          service_id: baseData.vendor_service_id,
          frequency: baseData.frequency || "one_time", // ✅ Ensure default
          duration: baseData.duration || "2hr",
          pet_size: baseData.petSize || 0, // Add if needed
          pet_breed: baseData.petBreed || 0, // Add if needed
        };
        break;

      case "dog_walking":
        payload = {
          vendor_id: baseData.vendor_id,
          client_id: baseData.client_id, // Add if needed
          pet_id: baseData.pet_id, // Add if needed
          service_type: "dog_walking",
          service_id: baseData.vendor_service_id,
          frequency: baseData.frequency,
          number_of_times: baseData.number_of_times,
        };
        break;

      default:
        payload = {
          vendor_id: baseData.vendor_id,
          client_id: baseData.client_id,
          pet_id: baseData.pet_id,
          vendor_service_id: baseData.vendor_service_id,
          pet_size: baseData.petSize || 0,
          pet_breed: baseData.petBreed || 0,
        };
        break;
    }

    console.log("Fetching price with payload:", payload); // Debug log

    const res = await axios.post(
      `${API_BASE_URL}/customer/getServicePriceByPet`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } },
    );

    if (res.data?.success && res.data.data?.price != null) {
      const data = res.data.data;
      const price = Number(data.price || 0);
      const taxAmt = Number(data.taxAmount || 0);

      // Reverse calculate: (Tax / Price) * 100
      const calculatedPercentage = price > 0 ? (taxAmt / price) * 100 : 0;

      return {
        ...data,
        taxPercentage: calculatedPercentage,
      };
    }
    return { price: 0, taxAmount: 0 };
  } catch (err) {
    console.error("Error fetching service price:", err);
    return 0;
  }
};

  useEffect(() => {
  const loadInitialData = async () => {
    try {
      setLoading(true);

      const storedBrand = localStorage.getItem("vendor_brand");
      if (storedBrand) setBrandName(storedBrand);

      if (clientId) {
        await Promise.all([
          fetchPets(),
          fetchCustomerDetails(),
          fetchPetTypes(),
          fetchBreeds(),
          fetchSizes(),
        ]);
      }
    } catch (err) {
      console.error("Initial load error:", err);
    } finally {
      setLoading(false);
    }
  };

  loadInitialData();
}, [clientId]);

  const buildPriceMeta = (data, currentItem) => {
  const surcharges = data.surchargeDetails || [];
  const totalPrice = Number(data.price || 0);
  const taxAmount = Number(data.taxAmount || 0);

  // Quick check: is this a boarding service?
  const isBoarding = (currentItem?.item_type || currentItem?.service_type || "")
    .toLowerCase()
    .includes("boarding");

  // For boarding we need days to reconstruct base_price_per_day
  const days = isBoarding ? Number(currentItem?.duration || 1) : 1;

  // Sum of surcharges (as returned by API)
  const surchargeSum = surcharges.reduce((sum, s) => sum + Number(s.price || 0), 0);

  let priceMeta = {
    surchargeDetails: surcharges,     // always keep original from API
    taxAmount,
    final_price: totalPrice,
  };

  if (isBoarding) {
    // Boarding-specific: API gives per-day surcharges + total price
    // So we can reverse-engineer base per day
    const pricePerDay = totalPrice / days;                    // e.g. 1188 / 2 = 594
    const basePerDay = Math.round(pricePerDay - surchargeSum); // 594 - 95 = 499

    priceMeta = {
      ...priceMeta,
      base_price_per_day: basePerDay,   // matches BoardingCalendarModel
      days,                             // matches BoardingCalendarModel
     // base_price: basePerDay * days,    // total base (optional, for consistency)
    };
  } else {
    // Grooming / other services: simple total-based (your current logic)
    const basePrice = totalPrice - surchargeSum;
    priceMeta = {
      ...priceMeta,
      base_price: Math.round(basePrice),   // correct for grooming
    };
  }

  return priceMeta;
};

   const hasShownCompatibilityToast = useRef(false);
  // ------------------ AUTO ASSIGN SINGLE PET ------------------
  //useEffect(() => {
    //const autoAssignSinglePet = async () => {
      //if (
      //  !autoAssigned &&
       // userPhone &&
       // pets.length === 1 &&
        //cartItems.length > 0
     // ) {
       // const singlePet = pets[0];

        // 🧠 Step 1: Check if this pet is compatible with ALL cart items
      //const incompatibleItems = cartItems.filter(
      //  (item) => !isPetAllowedForThisService(singlePet, item)
     // );
      // if (incompatibleItems.length > 0) {
  //if (!hasShownCompatibilityToast.current) {
    //toast.warning(
    //  "your pet is not compatible with the service.Please add pet."
   // );
   // hasShownCompatibilityToast.current = true;
 // }
  //return;
//}

       // const singlePetId = singlePet._id;

        // clone existing cart
        //let updatedCart = [...cartItems];
       // for (let i = 0; i < updatedCart.length; i++) {
         // const item = updatedCart[i];
           //const isCompatible = isPetAllowedForThisService(singlePet, item);
         //  const isCompatible = isPetFullyCompatible(singlePet, item);
           // ❌ If NOT compatible → skip pricing
         // if (!isCompatible) {
           // updatedCart[i] = {
             // ...item,
             // vendor_pet_id: null,
            //  price_api_loaded: false,
           // };
           // continue;
          //}
          // ✅ Assign pet ID if missing
          //if (!item.vendor_pet_id) {
          //  updatedCart[i] = { ...item, vendor_pet_id: singlePetId };
         // }
         //updatedCart[i] = {
         // ...item,
         // vendor_pet_id: singlePetId,
       // };

          // Build pricing data
         // const baseData = {
           // vendor_id: item.vendor_id || vendorID || guestvendorid,
           // client_id: clientId,
          //  pet_id: singlePetId,
          //  vendor_service_id: item.service_id || item.vendor_service_id,
            //petSize: singlePet.size,
          //  petBreed: singlePet.breed,
           // service_id: item.service_id,
            //room_type_id: item.room_type_id,
          //  room_type_id:
            //  item.room_type_id || item.room_id || item.vendor_service_id,
          //  checkin_date: item.start_date,
          //  checkout_date: item.end_date,
          //  frequency: item.frequency,
          //  duration: item.duration,
          //  number_of_times: item.number_of_times,
         // };

          // 1. Fetch the full result object (Price + Tax)
         // const priceResult = await fetchServicePrice(
          //  item.service_type || item.item_type,
          //  baseData
         // );

          // EXTRACT PRICE AND TAX DATA
         // const unitPrice = Number(priceResult?.price || 0);
         // const taxAmt = Number(priceResult?.taxAmount || 0);

          // Calculate percentage: (tax / price) * 100
         // const calculatedTaxRate =
         //   unitPrice > 0 ? (taxAmt / unitPrice) * 100 : 0;
        
         // const priceMeta = buildPriceMeta(priceResult, item);

       //   updatedCart[i] = {
          //  ...item,
         //   vendor_pet_id: singlePetId,
            // Extract values from priceResult (Assuming fetchServicePrice now returns the object)
         //   unit_price: Number(priceResult?.price || 0),
         //   tax_amount: Number(priceResult?.taxAmount || 0),
          //  tax_rate: calculatedTaxRate,
          //  surcharge_details: priceResult?.surchargeDetails || [],
          //  priceMeta,
           //  price_api_loaded: true,
             
          //};
        //}

        // ✅ Update cart in context and sessionStorage
      //  setCartItems(updatedCart);
       // sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

       // setAutoAssigned(true);
     // }
    //};

    //autoAssignSinglePet();
  //}, [
   // pets,
    //userPhone,
    //cartItems,
    //autoAssigned,
    //clientId,
    //vendorID,
    //guestvendorid,
    //fetchServicePrice,
  //]);

  useEffect(() => {
  if (!pets.length || !cartItems.length) return;

  let updated = cartItems.map(item => {
    if (!item.vendor_pet_id) return item;

    const pet = pets.find(p => p._id === item.vendor_pet_id);
    if (!pet) return item;

    // 🧠 Detect change
    const petChanged =
      item.petSize !== pet.size ||
      item.petBreed !== pet.breed;

    if (petChanged) {
      return {
        ...item,
        petSize: pet.size,
        petBreed: pet.breed,
        price_api_loaded: false, // 🔥 FORCE REFRESH
      };
    }
    return item;
  });
  setCartItems(updated);
  sessionStorage.setItem("cartItems", JSON.stringify(updated));
}, [pets]);

  useEffect(() => {
    const refreshPricesForMultiplePets = async () => {
      // 1. Guard: Only run if we have user info, items, and the pets list is actually loaded
      
      const isGuest = !userPhone;
      if (isGuest && cartItems.length === 0) return;
      if (!isGuest && (!userPhone || !clientId || pets.length === 0)) return;

     // if (
        //!userPhone ||
       // !clientId ||
       // pets.length === 0 ||
       // cartItems.length === 0
     //)
       // return;

      let needsUpdate = false;
      const updatedCart = await Promise.all(
        cartItems.map(async (item) => {
          // 2. Only target items that have a pet assigned but haven't loaded the dynamic price yet
          if (item.vendor_pet_id && !item.price_api_loaded) {
            const selectedPet = pets.find((p) => p._id === item.vendor_pet_id);

            if (selectedPet) {
              // Extract IDs directly from your API response structure
              const pSize = selectedPet.size;
              const pBreed = selectedPet.breed;

              // 3. CRITICAL: Only call API if we have the IDs to avoid 400 Bad Request
             // if (pSize && pBreed) {
             if (pSize ) {
                const baseData = {
                  vendor_id: item.vendor_id || vendorID || guestvendorid,
                  client_id: clientId,
                  pet_id: item.vendor_pet_id,
                  vendor_service_id: item.service_id || item.vendor_service_id,
                  petSize: pSize,
                  petBreed: pBreed,
                  service_id: item.service_id || item.vendor_service_id,
                  //room_type_id: item.room_type_id,
                  room_type_id: item.room_type_id || item.room_id,
                  checkin_date: item.start_date,
                  checkout_date: item.end_date,
                  frequency: item.frequency,
                  duration: item.duration,
                  number_of_times: item.number_of_times,
                };

                const priceResult = await fetchServicePrice(
                  item.service_type || item.item_type,
                  baseData
                );
                 
                const priceMeta = buildPriceMeta(priceResult, item); 

                const unitPrice = Number(priceResult?.price || 0);
                const taxAmt = Number(priceResult?.taxAmount || 0);
                const calculatedTaxRate =
                  unitPrice > 0 ? (taxAmt / unitPrice) * 100 : 0;

                needsUpdate = true;
                return {
                  ...item,
                  unit_price: Number(priceResult?.price || 0),
                  tax_amount: Number(priceResult?.taxAmount || 0),
                  tax_rate: calculatedTaxRate,
                  surcharge_details: priceResult?.surchargeDetails || [],
                  priceMeta,
                  price_api_loaded: true,
                };
              }
            }
          }
          return item;
        })
      );

      if (needsUpdate) {
        setCartItems(updatedCart);
        sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
        // Reset discount so it triggers now that we have real unit_prices
        setDiscountCalculated(false);
      }
    };

    refreshPricesForMultiplePets();
   console.log("Refresh running - pets:", pets.length, "assigned pets:", cartItems.filter(i => i.vendor_pet_id).length);
  }, [pets, cartItems, clientId]); // Re-run when pets list arrives or cart size changes

  
  // ------------------ MERGE GUEST CART AFTER LOGIN ------------------
  const hasMergedAfterLogin = useRef(false);

  useEffect(() => {
    const mergeGuestCartAfterLogin = async () => {

       // if (hasMergedAfterLogin.current) return;

      if (userPhone && cartItems.length > 0) {
        // Find guest items without pet assigned
        const guestItemsWithoutPet = cartItems.filter(
          (item) => !item.vendor_pet_id
        );

       // if (guestItemsWithoutPet.length > 0) {
         // if (pets.length === 0) {
          //  toast.success("Guest cart merged with your account");
          //  hasMergedAfterLogin.current = true;
         //   return;
         // } 
       // if (pets.length === 1) {
         // const singlePet = pets[0];
         // const hasIncompatibleItem = cartItems.some(
        //    (item) => !isPetFullyCompatible(singlePet, item)
         // );

         // if (hasIncompatibleItem) {
            // ❌ DO NOT assign
           // return;
        //  }

         // const updatedCart = cartItems.map((item) =>
          //  !item.vendor_pet_id
           //   ? { ...item, vendor_pet_id: singlePet._id }
            //  : item
         // );

          //setCartItems(updatedCart);
          //sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
         // toast.success("Guest cart items updated with your pet");
         // hasMergedAfterLogin.current = true;
       // }
     // }
      }
    };

    mergeGuestCartAfterLogin();
  }, [userPhone, pets, cartItems, clientId, vendorID, guestvendorid]);

 
  // Minimal Auto-assign: First compatible pet (works for both 1 or many pets)
 //useEffect(() => {
  //if (!userPhone || !pets.length || !cartItems.length) return;
  //if (hasMergedAfterLogin.current) return;

  //let updated = [...cartItems];
  //let changed = false;

  //updated = updated.map(item => {
    // ✅ If already valid → keep
   // if (item.vendor_pet_id) {
     // const pet = pets.find(p => p._id === item.vendor_pet_id);
    //  if (pet && isPetFullyCompatible(pet, item)) return item;
    //}

    // ✅ Find first compatible pet
   // const compatiblePet = pets.find(p => isPetFullyCompatible(p, item));

    //if (!compatiblePet) {
     // if (item.vendor_pet_id !== null) changed = true;
    //  return { ...item, vendor_pet_id: null };
   // }

    //changed = true;
    //return {
     // ...item,
    //  vendor_pet_id: compatiblePet._id,
    //  price_api_loaded: false,
   // };
  //});

  //if (changed) {
   // setCartItems(updated);
   // sessionStorage.setItem("cartItems", JSON.stringify(updated));
   // setDiscountCalculated(false);
 // }

  //hasMergedAfterLogin.current = true;
//}, [pets, userPhone]);

useEffect(() => {
  if (pets.length === 0 || cartItems.length === 0) return;

  setCartErrors(prev => {
    const updated = { ...prev };
    let changed = false;

    cartItems.forEach((item, i) => {
      const pet = pets.find(p => p._id === item.vendor_pet_id);
      if (pet && isPetFullyCompatible(pet, item)) {
        if (updated[i]) {
          delete updated[i];
          changed = true;
        }
      }
    });

    return changed ? updated : prev; // Avoid unnecessary re-render
  });
}, [cartItems, pets]);


  const buildDiscountPayload = ({
    cartItems = [],
    clientId,
    vendorID,
    guestvendorid,
    pets = [],
    petTypes = [],
    petBreeds = [],
    petSizes = [],
  }) => {
        
    const isGuest = !clientId;
    // ✅ Always resolve vendor_id from cart if context IDs aren't ready yet
    const resolvedVendorId = vendorID || guestvendorid || cartItems[0]?.vendor_id;

    return {
      client_id: clientId || 0,
      //vendor_id: vendorID || guestvendorid,
       vendor_id: resolvedVendorId,
      items: cartItems.map((item) => {
        //const pet = pets.find((p) => p._id === item.vendor_pet_id) || {};

        // Look up pet metadata
       // const petTypeObj = petTypes.find((t) => t._id === pet.pet_type);
       // const petBreedObj = petBreeds.find((b) => b._id === pet.breed);
        //const petSizeObj = petSizes.find((s) => s._id === pet.size);
         let petTypeName = "";
      let petBreedName = "";
      let petSizeValue = 0;
      
      if (!isGuest && item.vendor_pet_id) {
        const pet = pets.find((p) => p._id === item.vendor_pet_id);
        if (pet) {
          const petTypeObj = petTypes.find((t) => t._id === pet.pet_type);
          const petBreedObj = petBreeds.find((b) => b._id === pet.breed);
          petTypeName = petTypeObj?.name || "";
          petBreedName = petBreedObj?.breed_name || "";
          petSizeValue = pet.size || 0;
        }
      }
        return {
          item_type: (item.item_type || item.service_type || "").toLowerCase(),
          vendor_pet_id: item.vendor_pet_id || 0 ,
          service_id: item.service_id || item.vendor_service_id,
          //pet_type: petTypeObj?.name || "",
          //pet_breed: petBreedObj?.breed_name || 0,
          //pet_size: pet.size || 0,
          pet_type: petTypeName,
          pet_breed: petBreedName,
          pet_size: petSizeValue,
          // pet_id: pet._id || item.vendor_pet_id,
          pet_id: item.vendor_pet_id,
          quantity: item.quantity || 1,
          unit_price: Number(item.unit_price || item.price || 0),
          addons: Array.isArray(item.addons) ? item.addons : [],
          ...(item.item_type?.toLowerCase() === "grooming" && {
            start_date: item.start_date,
            duration: `${item.duration} Minutes`,
          }),
          ...(item.item_type?.toLowerCase() === "boarding" && {
            service_id:
              item.service_id || item.room_service_id || item.vendor_service_id,
            room_type_id: item.room_type_id,
            start_date: item.start_date,
            end_date: item.end_date,
            duration: item.duration,
          }),
        };
      }),
    };
  };

  const isDiscountPayloadValid = (cartItems, clientId) => {
    //if (!clientId) return false;
    if (!Array.isArray(cartItems) || !cartItems.length) return false;

    return cartItems.every(
      (item) => item.vendor_pet_id && (item.unit_price || item.price)
    );
  };

  const [discountCalculated, setDiscountCalculated] = useState(false);
  const [discountData, setDiscountData] = useState(null);

  useEffect(() => {
    // Check if we have everything needed to calculate discount
    const isReady =
      //clientId &&
      //cartItems.length &&
     // pets.length &&
     // petTypes.length &&
      //petBreeds.length &&
     // petSizes.length;
     cartItems.length > 0 ;

    if (!isReady) return; // Wait until all data is loaded
    if (discountCalculated) return; // Only calculate once

    // ✅ Guard: ensure we have a valid vendor_id before calling
  const resolvedVendorId = vendorID || guestvendorid || cartItems[0]?.vendor_id;
  if (!resolvedVendorId) return; // wait until vendor is resolved


    const payload = buildDiscountPayload({
      cartItems,
      clientId,
      //vendorID,
      vendorID: resolvedVendorId,
      guestvendorid,
      pets,
      petTypes,
      petBreeds,
      petSizes,
    });

     console.log("🔍 DISCOUNT PAYLOAD:", JSON.stringify(payload, null, 2));

    const fetchDiscount = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/customer/getDiscountCalculation`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("📥 DISCOUNT RESPONSE:", res.data);
        if (res.data?.success === true) {
          setDiscountData(res.data.data);
          setDiscountCalculated(true);
        } else {
          console.warn(
            "⚠️ API returned success: false or missing key",
            res.data
          );
        }
      } catch (err) {
        console.error("❌ Discount API failed:", err);
      }
    };

    fetchDiscount();
  }, [cartItems, clientId, pets, petTypes, petBreeds, petSizes]);

  //useEffect(() => {
   // if (
    //  !clientId ||
    //  !cartItems.length ||
     // !pets.length ||
    //  !petTypes.length ||
    //  !petBreeds.length ||
     // !petSizes.length
   // ) {
   //   return;
    //}
    //if (discountCalculated) return;

    //const payload = buildDiscountPayload({
      //cartItems,
     // clientId,
     // vendorID,
     // guestvendorid,
     // pets,
     // petTypes,
     // petBreeds,
     // petSizes,
   // });

    // call API here
  //}, [cartItems, clientId, pets, petTypes, petBreeds, petSizes]);


   // Add this new state near your other state declarations (around line 200)
  //const [orderDiscountData, setOrderDiscountData] = useState(null);
  //const [orderDiscountCalculated, setOrderDiscountCalculated] = useState(false);
// Add this useEffect after your existing discountData useEffect (around line 700)
 // useEffect(() => {
    // Calculate subtotal and taxamount for order discount API
   // const calculateOrderDiscount = async () => {
      // Wait until we have the base discount calculated and cart items ready
      //if (!discountCalculated || !cartItems.length || orderDiscountCalculated) return;
     // const hasDiscounts = cartItems.some(item => getItemDiscount(item) > 0);
  //  if (!cartItems.length || orderDiscountCalculated || !hasDiscounts) return;
      
    // Calculate subtotal (sum of all item amounts after discount)
    //  const subtotal = cartItems.reduce((sum, item) => {
     //   const price = Number(item.unit_price || 0);
      //  const discount = getItemDiscount(item);
     //   return sum + (price - discount);
    //  }, 0);
      
      // Calculate total tax amount
    //  const taxamount = cartItems.reduce((sum, item) => sum + getDisplayTax(item), 0);
      
     // const vendorId = vendorID || guestvendorid || cartItems[0]?.vendor_id;
      
     // if (!vendorId) return;
      
     // try {
      //  const response = await axios.post(
       //   `${API_BASE_URL}/vendororder/getVendorOrderDiscount`,
        //  {
        //    vendorId: vendorId,
         //   subtotal: subtotal,
        //    taxamount: taxamount
        //  },
         // {
          //  headers: { Authorization: `Bearer ${token}` }
       //   }
       // );
        
      //  if (response.data?.status) {
         // setOrderDiscountData(response.data.data);
       //   setOrderDiscountCalculated(true);
       // }
    //  } catch (err) {
      //  console.error("Order discount API failed:", err);
    //  }
   // };
    
   // calculateOrderDiscount();
 // }, [discountCalculated, cartItems, orderDiscountCalculated, vendorID, guestvendorid]);

  //useEffect(() => {
   // setOrderDiscountCalculated(false);
   // setOrderDiscountData(null);
 // }, [cartItems]);

  const hasShownExpiredToast = useRef(false);
    useEffect(() => {
      if (!cartItems.length) return;
  
      const today = new Date();
      today.setHours(0, 0, 0, 0);
  
      const expiredIds = cartItems
        .filter((item) => {
          const itemDate = new Date(item.start_date || item.date);
          itemDate.setHours(0, 0, 0, 0);
          return itemDate < today;
        })
        .map((item) => item.cartItemId || item._id);
  
      if (expiredIds.length > 0) {
            expiredIds.forEach((id) =>{
          removeFromCart(id, { silent: true }) // ✅ silent
      });  
        if (!hasShownExpiredToast.current) {
      hasShownExpiredToast.current = true;
      toast.warning(`${expiredIds.length} expired item(s) were removed from your cart`);
    }
  } else {
    // Reset the flag when no expired items exist
    hasShownExpiredToast.current = false;
  }
    }, [cartItems, removeFromCart]);

  // ------------------ HELPERS ------------------
  // Update Secondary User
const handleUpdateSecondaryUser = async (secondaryUserId, updatedData, newPhone, otp) => {
  if (!secondaryUserId) {
    toast.error("Invalid user ID");
    return false;
  }

  setLoading(true);
  try {
    let payload;

    // Prepare address object
    const address = {
      street: updatedData.street || '',
      landmark: updatedData.landmark || '',
      city: updatedData.city || '',
      state: updatedData.state || '',
      pincode: updatedData.pincode || ''
    };

    // Check if phone number is being changed
    if (newPhone && newPhone !== updatedData.phone) {
      if (!otp) {
        toast.error("OTP is required to verify new phone number");
        return false;
      }

      payload = {
        name: updatedData.name,
        email: updatedData.email,
        newPhone: newPhone,
        otp: otp,
        address: address
      };
    } else {
      payload = {
        name: updatedData.name,
        email: updatedData.email,
        address: address
      };
    }

    console.log("Update payload:", payload);

    const response = await axios.put(
      `${API_BASE_URL}/customer/updatesecondaryuser/${secondaryUserId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    console.log("Update response:", response.data);

    if (response.data.status) {
        await refetchCustomer();
      toast.success('Secondary user updated successfully!');
      return true;
    } else {
      toast.error(response.data.message || 'Failed to update secondary user');
      return false;
    }
  } catch (error) {
    console.error('Update Secondary User Error:', error);
    toast.error(error.response?.data?.message || 'Network error. Please try again.');
    return false;
  } finally {
    setLoading(false);
  }
};

// Send OTP for phone update
const sendPhoneUpdateOTP = async (secondaryUserId, newPhone) => {
  if (!newPhone || newPhone.length !== 10) {
    toast.error("Please enter a valid 10-digit phone number");
    return false;
  }

  setLoading(true);
  try {
    const payload = {
      phone: newPhone,
      isUpdate: true,
      secondaryUserId: secondaryUserId
    };

    const response = await axios.post(
      `${API_BASE_URL}/customer/sendsecondaryotp`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    if (response.data.status) {
      toast.success('OTP sent successfully!');
      return true;
    } else {
      toast.error(response.data.message || 'Failed to send OTP');
      return false;
    }
  } catch (error) {
    console.error('Send OTP Error:', error);
    toast.error(error.response?.data?.message || 'Network error. Please try again.');
    return false;
  } finally {
    setLoading(false);
  }
};


  const getPetTypeName = (id) =>
    petTypes.find((t) => t._id === id)?.name || "-";
  const getBreedName = (id) =>
    petBreeds.find((b) => b._id === id)?.breed_name || "-";
  //const getSizeLabel = (id) =>
  //  petSizes.find((s) => s._id === id)?.size_label || "-";
  const getPetSizeId = (sizeLabel) =>
    petSizes.find(
      (s) => s.size_label.toLowerCase() === sizeLabel?.toLowerCase()
    )?._id;
  const getSizeLabel = (id) => {
    if (!id) return "-";
    if (!petSizes || petSizes.length === 0) return "Loading...";

    const foundSize = petSizes.find(
      (s) =>
        String(s.flps_pet_size_id) === String(id) ||
        String(s._id) === String(id)
    );

    if (!foundSize) return "-";

    return foundSize.size_label || "-";
  };

  const validateCartBeforePayment = () => {
    const errors = {};
    cartItems.forEach((item, i) => {
     // if (!item.vendor_pet_id)
      //  errors[i] = "Please select a pet for this service";
     const pet = pets.find(p => p._id === item.vendor_pet_id);

    if (!pet) {
      errors[i] = "Please select a pet";
    } else if (!isPetFullyCompatible(pet, item)) {
      errors[i] = "This pet is not compatible with this service";
    }
    });
   
    setCartErrors(errors);
    return Object.keys(errors).length === 0;
  };

   // Add this helper function to check if any service is missing a pet
const hasMissingPetAssignment = () => {
  if (!cartItems || cartItems.length === 0) return false;
  
  return cartItems.some((item, i) => {
    const pet = pets.find(p => p._id === item.vendor_pet_id);
    return !pet || !item.vendor_pet_id;
  });
};

// Get count of services missing pet assignment
const getMissingPetCount = () => {
  if (!cartItems || cartItems.length === 0) return 0;
  
  return cartItems.filter((item) => {
    const pet = pets.find(p => p._id === item.vendor_pet_id);
    return !pet || !item.vendor_pet_id;
  }).length;
};

   const getDisplayPetSize = (item) => {
    return item?.petSize?.size_label || "-";
  };

const isBoardingItem = (item) => {
  const type = (item.item_type || item.service_type || "").toLowerCase();
  return type.includes("boarding");
};
 

  const handleProceedToPayment = () => {
    if (!validateCartBeforePayment()) {
      toast.error("Please select a pet for all services before proceeding.");
      return;
    }

    // Calculate subtotal after service discounts
  const subtotalAfterServiceDiscount = subtotal - totalDiscount;
  
  // Use order discount values if available, otherwise use service discounts only
  //const finalAmountAfterOrderDiscount = orderDiscountData 
  //  ? orderDiscountData.amount_after_discount 
   // : subtotalAfterServiceDiscount;
    
  //const finalTaxAmount = orderDiscountData 
   // ? orderDiscountData.tax_amount_after_discount 
  //  : totalGST;
    
 // const finalTotal = finalAmountAfterOrderDiscount + finalTaxAmount;

   const finalItemsForPayment = cartItems.map((item) => {
    // Base values (already in item)
    const basePrice = Number(item.unit_price || item.price || 0);
    const itemDiscount = getItemDiscount(item); // from discountMap – correct
     const discountInfo = getItemDiscountInfo(item);
    const itemTax = getDisplayTax(item);        // prefers priceMeta.taxAmount → most accurate

    // Derived values – this is what Payment page needs
    const taxable = basePrice - itemDiscount;
    const finalForItem = taxable + itemTax;
    const assignedPet = pets.find((p) => p._id === item.vendor_pet_id);
    return {
      ...item, // keep everything else (dates, pet, service_id, etc.)     
      // notes: itemNotes[item.cartItemId || item._id] || "",
      // ── Critical snapshot fields ────────────────────────────────
      petName: assignedPet?.name || item.petName || "",
      unit_price:  basePrice,                  // original base
      amount_without_tax: basePrice,
      discount_amount:   itemDiscount,
      discount: discountInfo,
      amount_after_discount: taxable,
      tax_amount:           itemTax,
      tax_percentage:       Number(item.tax_rate || item.priceMeta?.taxPercentage || 0),
      amount_with_tax:      finalForItem,
      total_price:          finalForItem,               // final payable per item

      // Keep your helpers (optional but good for consistency)
     // calculatedGst:        itemTax,
      //calculatedDiscount:   itemDiscount,
     // calculatedTaxRate:    item.tax_rate || 0,
     calculatedTaxRate: item.tax_rate || 0,
     calculatedGst: getItemGST(item), // Your existing UI tax calc
     calculatedDiscount: getItemDiscount(item),

      service_id:           item.service_id || item.vendor_service_id,
      vendor_pet_id:        item.vendor_pet_id,
      

    };
  });
  
    navigate("/payment", {
      state: {
        totalAmount: parseFloat(total),
        //subtotal: subtotal,
        //totalAmount: finalTotal,
    subtotal: subtotalAfterServiceDiscount,
        totalDiscount: totalDiscount,
        totalGST: totalGST,
        
         // ✅ VERY IMPORTANT
   // orderDiscountMeta: orderDiscountData
     // ? {
        //  discount_type: orderDiscountData.discount_type,
        //  discount_value: orderDiscountData.discount_value,
        //  discount_amount: orderDiscountData.discount_amount,
        //  amount_after_discount: orderDiscountData.amount_after_discount,
        //  tax_amount_after_discount:
        //    orderDiscountData.tax_amount_after_discount,
      //  }
     // : null,

        brandName,
        serviceName: cartItems?.[0]?.name || "Selected Service",
        cartItems: finalItemsForPayment, // Pass the enriched items
        showMessage: true,
      },
    });

    // navigate("/payment", { state: { totalAmount: parseFloat(total) , brandName } });
  };

  const formatDiscountTooltip = (discounts = []) => {
  if (!discounts.length) return "No discount applied";

  return discounts
    .map((d) => {
      const name = d.name.replace(/_/g, " ").toUpperCase();

      if (d.type === "percentage") {
        return `${name}: ${d.value}% OFF`;
      }

      return `${name}: ₹${d.discount_amount} OFF`;
    })
    .join(" • ");
};

  const handleLoginClick = () => setIsPhoneModelOpen(true);
  const closePhoneModel = () => setIsPhoneModelOpen(false);

  const handleAddPet = () => {
    setEditingPet(null);
    setDrawerOpen(true);
  };
  
const handleAddPetDetail = (serviceItem, index) => {   
  console.log("🔍 serviceItem.service_id:", serviceItem?.service_id);
  console.log("🔍 serviceItem._id:", serviceItem?._id);
  console.log("🔍 serviceItem.id:", serviceItem?.id);
  
  setQuickAddServiceIndex(index);
  setEditingPet(null);
  console.log("🔍 handleAddPet called with serviceItem:", serviceItem);
  if (user && serviceItem) {
  const petDataFromService = {
    pet_type_id:
      serviceItem.pet_type?.pet_type_id || serviceItem.pet_type,
    petSize_id:
      serviceItem.petSize?.flps_pet_size_id || serviceItem.petSize,
    petBreed_id:
      serviceItem.petBreed || serviceItem.petBreedId || null,
  };
  console.log("🔍 PetData From Service in pet drawer:", petDataFromService);
  setSelectedGuestPet(petDataFromService);
  setQuickAddMode(true); // ✅ KEY
}
  
  setDrawerOpen(true);
};


  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setEditingPet(null);
     setSelectedGuestPet(null);
      setQuickAddMode(false);
      setQuickAddServiceIndex(null);

  };
  //const handleSavePet = async () => {
    //setDrawerOpen(false);
   // await fetchPets();
   // setCartErrors({});

    //if (quickAddServiceIndex !== null && quickAddMode) {
    // Wait for pets to update
   // setTimeout(() => {
     // const newlyAddedPet = pets[pets.length - 1];
     // if (newlyAddedPet && quickAddServiceIndex !== null) {
        // Auto-assign to the service
     //   handlePetSelect(newlyAddedPet._id, quickAddServiceIndex);
    // }
      // Reset
      //setQuickAddServiceIndex(null);
      //setQuickAddMode(false);
      //setSelectedGuestPet(null);
   // }, 300);
  //}
     
   // setSelectedGuestPet(null);
   // if (guestPetData) {
    //clearGuestPetData();
    //sessionStorage.removeItem('guest_pet_data_v1');
 // }
  //};

  const handleSavePet = async () => {
  setDrawerOpen(false);
  
  // Store the index before fetching
  const serviceIndex = quickAddServiceIndex;
  
  // Fetch pets and wait for it to complete
  if (!clientId) return;
  
  try {
    const response = await axios.post(
      `${API_BASE_URL}/customer/getallpet`,
      { client_id: clientId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const newPetsList = response.data?.pets || [];
    setPets(newPetsList);
    
    // If we were adding pet for a specific service
    if (serviceIndex !== null && quickAddMode) {
      // Get the newly added pet (last one in the array)
      const newlyAddedPet = newPetsList[newPetsList.length - 1];
      
      if (newlyAddedPet) {
        // Directly update cart without calling handlePetSelect to avoid async issues
        const targetItem = cartItems[serviceIndex];
        if (isPetFullyCompatible(newlyAddedPet, targetItem)) {
          const updatedCart = [...cartItems];
          updatedCart[serviceIndex] = {
            ...targetItem,
            vendor_pet_id: newlyAddedPet._id,
            price_api_loaded: false
          };
          setCartItems(updatedCart);
          sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
          setDiscountCalculated(false);
          toast.success(`Pet "${newlyAddedPet.name}" assigned to service`);
        }
      }
    }
  } catch (error) {
    console.error("Error fetching pets:", error);
    toast.error("Failed to save pet");
  }
  
  setCartErrors({});
  setSelectedGuestPet(null);
  setQuickAddServiceIndex(null);
  setQuickAddMode(false);
};

  const handleOpenCustomerDrawer = () => setIsCustomerDrawerOpen(true);
  const handleCloseCustomerDrawer = () => setIsCustomerDrawerOpen(false);

  const handleUpdateCustomer = async (payload) => {
    try {
      if (!payload) {
        await fetchCustomerDetails();
        return;
      }
      
      // Use the correct endpoint
      const response = await axios.post(
        `${API_BASE_URL}/customer/updatecustomer`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data?.success) {
        toast.success("Customer details updated successfully!");
        await fetchCustomerDetails(); // Refresh the data
        await refetchCustomer();
        setIsCustomerDrawerOpen(false); // Close the drawer
      } else {
        toast.error(response.data?.message || "Failed to update customer details");
      }
    } catch (err) {
      console.error("Update error:", err.response?.data || err.message);
      toast.error(err.response?.data?.message || "Failed to update customer details");
    }
  };

  const formatServiceType = (type) => {
    if (!type) return "";

    const lower = type.toLowerCase().trim();

    switch (lower) {
      // 🧼 Grooming variations
      case "home_grooming":
      case "home grooming":
      case "grooming":
      case "mobile pet grooming van":
      case "mobile_grooming_van":
      case "mobile grooming":
        return "Grooming";

      // 🩺 Vet Clinic variations
      case "vet":
      case "vet_clinic":
      case "vet services":
      case "pet vet clinic":
      case "vet clinic":
      case "pet clinic":
        return "Vet Clinic";

      // 🏠 Boarding
      case "boarding":
      case "home boarding":
        return "Boarding";

      // 🐶 Dog Walking
      case "dog_walking":
      case "dog walking":
      case "walking":
        return "Dog Walking";

      // 🧸 Day Care
      case "day_care":
      case "day care":
        return "Day Care";

      default:
        // Capitalize unknown ones safely
        return type
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
    }
  };

  // ✅ Handle pet selection and update price

  const handlePetSelect = async (selectedPetId, index) => {

  const selectedItem = cartItems[index];
  const selectedPet = pets.length === 1 ? pets[0] : pets.find(p => p._id === selectedPetId);


    if (!selectedPet) return toast.error("Invalid pet selected");

    setLoadingIndex(index);

    const petSizeId =
      selectedPet.size || selectedPet.pet_size || selectedPet.size_id || null;
    if (!petSizeId) {
      console.warn("❌ Price API blocked: pet_size missing");
      return;
    }

    const serviceType = (
      selectedItem.item_type ||
      selectedItem.service_type ||
      ""
    ).toLowerCase();
    const payloadBase = {
      vendor_id: selectedItem.vendor_id || vendorID || guestvendorid,
      client_id: clientId,
      pet_id: selectedPet._id,
      pet_size: petSizeId || 0,
      pet_breed: selectedPet.breed || 0,
      service_type: serviceType,
    };

    let payload;

    switch (serviceType) {
      case "boarding":
      case "kennel boarding": // Added this because your previous log showed this type
        payload = {
          ...payloadBase,
          // Ensure this is named EXACTLY 'service_id' for the API
          service_id:
            selectedItem.service_id ||
            selectedItem.room_service_id ||
            selectedItem.vendor_service_id,

          // Use room_id if room_type_id is null
          room_type_id: selectedItem.room_type_id || selectedItem.room_id,
          // Ensure dates are present
          checkin_date: selectedItem.start_date || selectedItem.checkin_date,
          checkout_date: selectedItem.end_date || selectedItem.checkout_date,
        };
        break;

      case "dog_walking":
        payload = {
          ...payloadBase,
          service_id: selectedItem.service_id || selectedItem.vendor_service_id,
          frequency: selectedItem.frequency || "daily", // ✅ Ensure this is not null/undefined
          number_of_times: selectedItem.number_of_times,
        };
        break;

      case "day_care":
      case "day_care services":
        payload = {
          ...payloadBase,
          service_type: "day_care",
          service_id: selectedItem.service_id || selectedItem.vendor_service_id,
          frequency: selectedItem.frequency || "one_time",
          duration: selectedItem.duration || "2hr",
          pet_size: petSizeId || 0,
          pet_breed: selectedPet.breed || 0,
        };
        break;

      case "grooming":
      case "home grooming":
      case "mobile pet grooming van":
      case "vet_clinic":
        payload = {
          ...payloadBase,
          service_id: selectedItem.service_id || selectedItem.vendor_service_id,
        };
        break;

      default:
        // fallback for unknown service type
        payload = {
          ...payloadBase,
          service_id: selectedItem.service_id || selectedItem.vendor_service_id,
        };
        break;
    }

    // Fetch price from API
    const res = await axios.post(
      `${API_BASE_URL}/customer/getServicePriceByPet`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setLoadingIndex(null);

    const priceData = res.data?.data;
   
    const oldPrice = Number(selectedItem.unit_price || 0);
    const newPrice = Number(priceData?.price || 0);

    // 🟡 If price changed → pause & show dialog
    if (oldPrice > 0 && oldPrice !== newPrice) {
      setPendingPriceUpdate({
        index,
        selectedPetId: selectedPet._id,
        priceData,
      });

      setPopupMessage(
        `Price updated due to pet-specific pricing.\n` +
      `₹${oldPrice.toFixed(2)} → ₹${newPrice.toFixed(2)}`
      );

      setShowPopup(true);
      setLoadingIndex(null);
      return; // ⛔ stop auto update
    }
    // REVERSE CALCULATE TAX RATE
    const price = Number(priceData.price || 0);
    const taxAmt = Number(priceData.taxAmount || 0);
    const calculatedTaxRate = price > 0 ? (taxAmt / price) * 100 : 0;
    
    const newPriceMeta = buildPriceMeta(priceData, selectedItem);
    const updatedCart = [...cartItems];
    updatedCart[index] = {
      ...selectedItem,
      vendor_pet_id: selectedPet._id,

      unit_price: Number(priceData.price),
      tax_amount: Number(priceData.taxAmount || 0),
      tax_rate: calculatedTaxRate,
      surcharge_details: priceData.surchargeDetails || [],
      
      priceMeta: newPriceMeta,

      price_api_loaded: true,
    };
    setCartItems(updatedCart);
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));

    const updatedPrice = Number(priceData?.price || 0);
    toast.success(`Price updated: ₹${updatedPrice.toFixed(2)}`);

    //toast.success(`Price updated: ₹${priceData}`);
      setDiscountCalculated(false);
      setTimeout(() => {
        setDiscountCalculated(false);
      }, 100);
  };

  const confirmPriceUpdate = () => {
    if (!pendingPriceUpdate) return;

    const { index, selectedPetId, priceData } = pendingPriceUpdate;
    const newPriceMeta = buildPriceMeta(priceData, cartItems[index]);

    const updatedItems = cartItems.map((c, i) =>
      i === index
        ? {
            ...c,
            vendor_pet_id: selectedPetId,
          unit_price: Number(priceData.price),
          price: Number(priceData.price),
          tax_amount: Number(priceData.taxAmount || 0),
          tax_rate:
            Number(priceData.price) > 0
              ? (Number(priceData.taxAmount || 0) / Number(priceData.price)) * 100
              : 0,
          surcharge_details: priceData.surchargeDetails || [],
          priceMeta: newPriceMeta,

          price_api_loaded: true,
          vendor_id: c.vendor_id || vendorID || guestvendorid,
        }
        : c
    );

    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    setDiscountCalculated(false);
  // Optional stronger force (recommended – helps in many cases) 
    setCartErrors((prev) => {
      const copy = { ...prev };
      delete copy[index];
      return copy;
    });
    toast.success("Price updated successfully");
    setShowPopup(false);
    setPendingPriceUpdate(null);
  };

  // 🔴 If user clicks Cancel
    const cancelPriceUpdate = () => {
      setShowPopup(false);
      setPendingPriceUpdate(null);
    };
    // ✅ Handle pet selection (with price update)
    const hasCartItems = Array.isArray(cartItems) && cartItems.length > 0;
    const discountMap = useMemo(() => {   
      const items =
      discountData?.items || (Array.isArray(discountData) ? discountData : []);
    const map = {};

    items.forEach((apiItem) => {
      const sId = apiItem.service_id;
      const pId = apiItem.vendor_pet_id || apiItem.pet_id;
      //if (!sId || !pId) return;
      if (!sId) {
      console.warn("⚠️ Skipping item - no service_id");
      return;
    }
      // ✅ ONLY ACTIVE DISCOUNTS
      const activeDiscounts = Array.isArray(apiItem.discount)
        ? apiItem.discount.filter(d => Number(d.is_active) === 1)
        : [];
      const totalDiscount = activeDiscounts.reduce(
        (sum, d) => sum + Number(d.discount_amount || 0),
        0
      );

      //const key = `${sId}_${pId}`;
      let key;
    if (!pId || pId === 0) {
      // Guest fallback: use only service_id as key
      key = `${sId}_guest`;
    } else {
      key = `${sId}_${pId}`;
    }
      map[key] = {
        amount: totalDiscount,
        info: activeDiscounts, // 👈 only active ones shown in tooltip
      };
    });
    return map;
  }, [discountData]);
 
  const getItemKey = (item) => {
    // Use the ID fields consistently.
    // API returns vendor_pet_id, so we ensure we look for that.
    const sId = item.service_id || item.vendor_service_id;
    const pId = item.vendor_pet_id || item.pet_id;

   // if (!sId || !pId) return null;
    if (!sId) return null;
  
  // ✅ Match the same logic as discountMap
  if (!pId || pId === 0) {
    return `${sId}_guest`;
  }

    return `${sId}_${pId}`;
  };
  const getItemDiscount = (item) => discountMap[getItemKey(item)]?.amount || 0;

  const getItemDiscountInfo = (item) =>
    discountMap[getItemKey(item)]?.info || [];

  const getItemGST = (item) => {
   const price = Number(item.unit_price || 0);
    const discount = getItemDiscount(item); // Returns 0 if no discount
    const taxRate = Number(item.tax_rate || 0);

    // Calculate GST on the price AFTER discount is removed
    const taxableAmount = price - discount;
    //return (taxableAmount * taxRate) / 100;
    // Calculate GST
  const gst = (taxableAmount * taxRate) / 100;
  return gst;
  };

  // ==================== ADD THIS HELPER ====================
const getDisplayTax = (item) => {
  const price = Number(item.unit_price || 0);
  const discount = getItemDiscount(item);

  let taxRate = Number(item.tax_rate || 0);

  // 🔥 Derive taxRate from priceMeta if missing
  if (taxRate === 0 && item.priceMeta?.taxAmount && price > 0) {
    taxRate = (Number(item.priceMeta.taxAmount) / price) * 100;
  }
  if (price > 0 && taxRate > 0) {
    const taxableAmount = price - discount;
    return (taxableAmount * taxRate) / 100;
  }
  // First try the normal calculation (works perfectly for logged-in users)
  //const calculated = getItemGST(item);
 // if (calculated > 0) {
  //  return calculated;
 // }

  // Guest fallback - only when normal calculation gives 0
  //if (!userPhone && item.priceMeta?.taxAmount != null) {
   // return Number(item.priceMeta.taxAmount);
 // }

     // Priority 2: Direct tax_amount (if present)
  if (item.tax_amount != null && Number(item.tax_amount) > 0) {
    return Number(item.tax_amount);
  }

  // Priority 3: Guest fallback (priceMeta)
  if (item.priceMeta?.taxAmount != null) {
    return Number(item.priceMeta.taxAmount);
  }

  // Priority 4: legacy gst field
  if (item.gst != null && Number(item.gst) > 0) {
    return Number(item.gst);
  }

  return 0;
};
  
  const getItemTotalWithTax = (item) => {
    const price = Number(item.unit_price || 0);
    const discount = getItemDiscount(item);
    const gst = getItemGST(item);

    // Final amount user pays for this specific item
    return price - discount + gst;
  };

  const getItemSubtotal = (item) => Number(item.unit_price || 0);

  // ------------------ PRICE CALCULATION ------------------
  const getItemTotal = (item) => {
    const price = item.unit_price || item.price || 0;

    return price;
  };

  const getSubtotal = () =>
    cartItems.reduce((sum, item) => sum + getItemTotal(item), 0);

  // 1. Sum of all original unit prices
  const subtotal = cartItems.reduce(
    (sum, item) => sum + Number(item.unit_price || 0),
    0
  );
  // 2. Sum of all calculated discounts
  const totalDiscount = cartItems.reduce(
    (sum, item) => sum + getItemDiscount(item),
    0
  );
  // 3. Sum of GST (each calculated on its own discounted base)
  const totalGST = cartItems.reduce((sum, item) => sum + getDisplayTax(item), 0);
  const total = subtotal - totalDiscount + totalGST;
   // Helper function to calculate final total after tier 2 discount
 // const calculateFinalTotal = () => {
  //  if (orderDiscountData?.discount_amount > 0) {
     // return (orderDiscountData.amount_after_discount + orderDiscountData.tax_amount_after_discount).toFixed(2);
   // }
   // return total.toFixed(2);
 // };
  // Helper to get subtotal after service discounts
  const getSubtotalAfterServiceDiscount = () => {
    return (subtotal - totalDiscount).toFixed(2);
  };
  // Helper to get display values for order discount section
 // const getOrderDiscountDisplay = () => {
    //if (!orderDiscountData?.discount_amount) return null;   
   // return {
    //  discountType: orderDiscountData.discount_type,
    //  discountValue: orderDiscountData.discount_value,
   //   discountAmount: orderDiscountData.discount_amount,
    //  amountAfterDiscount: orderDiscountData.amount_after_discount,
   //   taxAfterDiscount: orderDiscountData.tax_amount_after_discount
   // };
 // };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

   
 
       // ------------------ LOADER ------------------
   if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-100 via-amber-50 to-orange-100 flex items-center justify-center"> 
        <div className="bg-white px-10 py-8 rounded-3xl shadow-2xl flex flex-col items-center gap-6"> 
          {/* Spinner */}
          <div className="relative">
            <div className="w-12 h-12 border-4 border-orange-200 rounded-full"></div>
            <div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
          </div>
          {/* Loading Text */}
          <p className="text-xl font-semibold text-[#000048] tracking-wide animate-pulse">
            Loading<span className="animate-bounce">.</span>
            <span className="animate-bounce delay-150">.</span>
            <span className="animate-bounce delay-300">.</span>
          </p>
          <p className="text-sm text-gray-500">
            Please wait while we prepare your booking details
         </p>
        </div>
      </div>
    );
  }
const derivedBrandName =
  cartItems?.[0]?.vendor_name || brandName ;
  
  // ------------------ RENDER ------------------
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-100 via-amber-50 to-orange-100 px-3 py-4 sm:p-6 lg:p-8">
      <div className="mx-auto w-full max-w-7xl bg-white rounded-3xl shadow-2xl p-4 sm:p-8 lg:p-10 overflow-x-hidden">
        {/* Shop Name */}
        
          { derivedBrandName && (
          <div className="bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-2xl p-4 sm:p-5 mb-2 shadow-sm">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
              <div className="flex items-start sm:items-center gap-3 min-w-0">
              <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
              <h2 className="text-base sm:text-xl font-semibold text-[#000048] break-words">
                🏪 {derivedBrandName}
              </h2>
               </div>
                  {/* RIGHT: Actions */}
              <div className="flex flex-row flex-wrap items-center justify-between gap-4 sm:gap-5 lg:justify-end lg:pr-2">
                
                <button
                  onClick={() => navigate(-1)}
                  className="text-sm sm:text-base text-orange-600 font-bold hover:underline"
                >
                  ➕ Add More Services
                </button>

                <button
                  onClick={() => navigate("/shop-detail")}
                  className="text-sm sm:text-base text-gray-500 hover:text-orange-600 font-bold transition "
                >
                  Explore More
                </button>

              </div>
            </div>
             
          </div>
        )}
        <div className="flex items-center gap-4 mb-2 sm:mb-8">
          <h1 className="text-2xl leading-tight sm:text-4xl font-bold text-[#000048] tracking-tight">
            Confirm Your Booking
          </h1>
        </div>

        <div className="flex flex-col lg:flex-row gap-3 lg:gap-8">
          {/* LEFT SIDE */}
          <div className="w-full lg:w-[35%] space-y-1 sm:space-y-1 lg:space-y-6">
            {!userPhone ? (
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-3 sm:p-5 lg:p-6 rounded-2xl border border-orange-200 shadow-lg">
                <h2 className="text-xl sm:text-2xl font-semibold text-[#000048] mb-4">
                  Account
                </h2>
                <p className="text-[#000048] text-sm sm:text-base mb-6">
                  To book the service, please login or sign up
                </p>
                <button
                  onClick={handleLoginClick}
                  className="w-full py-3 px-5 bg-gradient-to-r from-[#FF9933] to-[#FF6600] text-white rounded-xl font-semibold text-base sm:text-lg hover:from-[#FF6600] hover:to-[#FF3300] shadow-md hover:shadow-xl"
                >
                  Login
                </button>
              </div>
                
            ) : (
              <>
                {/* Customer Info */}
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-4 sm:p-6 rounded-2xl border border-orange-200 shadow-lg space-y-2">
                  <h2 className="text-xl sm:text-2xl font-semibold text-[#000048] mb-2">
                    Account
                  </h2>
                  <p className="text-[#000048] text-base sm:text-lg font-medium mb-4 break-all">
                    +91 {userPhone}
                  </p>

                  {/* Customer Details */}
                  <div className="bg-white p-4 rounded-xl border border-orange-200 shadow-sm">
                    <button
                      onClick={toggleCustomerDetails}
                      className="flex items-center justify-between w-full text-left"
                    >
                      <div className="flex items-center gap-3">
                        <FaUser className="text-[#000048] w-5 h-5" />
                        <h2 className="text-lg sm:text-xl font-semibold text-[#000048]">
                          Customer Details
                        </h2>
                      </div>
                      <FaChevronDown
                        className={`text-[#000048] w-5 h-5 transition-transform duration-300 ${
                          isCustomerDetailsOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {/*{isCustomerDetailsOpen && (
                      <div className="mt-4 space-y-4 bg-white border border-orange-200 rounded-xl p-4 sm:p-5 shadow-sm">
                        {customerDetails?.firstname &&
                        customerDetails?.email ? (
                          <>
                            <div>
                              <label className="text-[#000048] font-medium">
                                Full Name
                              </label>
                              <input
                                type="text"
                                className="w-full bg-orange-50 mt-1 p-3 border border-gray-300 rounded-lg text-sm sm:text-base"
                                value=
                                //{`${customerDetails?.firstname ?? ""} ${
                                 // customerDetails?.lastname ?? ""
                               // }`}
                                {displayDetails?.name || ""}
                                readOnly
                              />
                            </div>

                            <div>
                              <label className="text-[#000048] font-medium">
                                Email
                              </label>
                              <input
                                type="email"
                                className="w-full bg-orange-50 mt-1 p-3 border border-gray-300 rounded-lg text-sm sm:text-base"
                                value=//{customerDetails.email}
                                       {displayDetails?.email || ""}

                                readOnly
                              /> 
                              {/* Right aligned Edit button */}
                            {/* <div className="flex justify-end mt-2">
                                <button
                                 // onClick={handleOpenCustomerDrawer}
                                
                                  onClick={() => {
                                  // Open SecondaryUserDrawer for secondary users
                                  setSelectedSecondaryUser({
                                    name: displayDetails?.name,
                                    email: displayDetails?.email,
                                    phone: displayDetails?.phone,
                                    address: displayDetails?.address
                                  });
                                  setIsSecondaryDrawerOpen(true);
                                  }}

                                 className="text-base text-orange-600 hover:text-orange-800 font-medium"
                                >
                                  Edit
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="text-center pt-3">
                            <p className="text-gray-700 mb-2">
                              Customer details are missing. Please add your
                              information.
                            </p>
                            <button
                              onClick={handleOpenCustomerDrawer}
                              className="py-2 px-5 bg-gradient-to-r from-[#FF9933] to-[#FF6600] text-white rounded-xl font-semibold text-sm hover:from-[#FF6600] hover:to-[#FF3300]"
                            >
                              + Add Customer Details
                            </button>
                          </div>
                        )}
                      </div>
                    )} */} 
                    {isCustomerDetailsOpen && (
                    <div className="mt-3 space-y-3 bg-white border border-orange-200 rounded-xl px-4 py-2 sm:p-5 shadow-sm">
                      {isSecUser ? (
                        // SECONDARY USER VIEW
                        <>
                          <div>
                            <label className="text-[#000048] font-medium">Full Name</label>
                            <input
                              type="text"
                              className="w-full bg-orange-50 mt-1 p-2 border border-gray-200 rounded-lg text-sm sm:text-base cursor-not-allowed"
                              value={displayDetails?.name || "Secondary User"}
                              readOnly
                              disabled
                            />
                          </div>
                          <div>
                            <label className="text-[#000048] font-medium">Email</label>
                            <input
                              type="email"
                              className="w-full bg-orange-50 mt-1 p-2 border border-gray-200 rounded-lg text-sm sm:text-base cursor-not-allowed"
                              value={displayDetails?.email || "Not provided"}
                              readOnly
                              disabled
                            />
                          </div>
                          <div className="flex justify-end mt-2">
                            <button
                              onClick={() => {                                
                                // Open SecondaryUserDrawer for secondary users
                                setSelectedSecondaryUser({ 
                                   _id: secondaryUserInfo.id,
                                  name: displayDetails?.name,
                                  email: displayDetails?.email,
                                  phone: displayDetails?.phone,
                                  address: displayDetails?.address
                                });
                                setIsSecondaryDrawerOpen(true);
                              }}
                              className="text-base text-orange-600 hover:text-orange-800 font-medium"
                            >
                              Edit
                            </button>
                          </div>
                        </>
                      ) : displayDetails?.name ? (
                        // PRIMARY USER VIEW
                        <>
                          <div>
                            <label className="text-[#000048] font-medium">Full Name</label>
                            <input
                              type="text"
                              className="w-full bg-orange-50 mt-1 p-3 border border-gray-200 rounded-lg text-sm sm:text-base"
                              value={displayDetails?.name || "Not provided"}
                              readOnly
                            />
                          </div>
                          <div>
                            <label className="text-[#000048] font-medium">Email</label>
                            <input
                              type="email"
                              className="w-full bg-orange-50 mt-1 p-3 border border-gray-200 rounded-lg text-sm sm:text-base"
                              value={displayDetails?.email || "Not provided"}
                              readOnly
                            />
                            <div className="flex justify-end mt-2">
                              <button
                                onClick={handleOpenCustomerDrawer}
                                className="text-base text-orange-600 hover:text-orange-800 font-medium"
                              >
                                Edit
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="text-center pt-3">
                          <p className="text-gray-700 mb-2">
                            Customer details are missing. Please add your information.
                          </p>
                          <button
                            onClick={handleOpenCustomerDrawer}
                            className="py-2 px-5 bg-gradient-to-r from-[#FF9933] to-[#FF6600] text-white rounded-xl font-semibold text-sm hover:from-[#FF6600] hover:to-[#FF3300]"
                          >
                            + Add Customer Details
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  </div>

                  {/* Pet List */}
                  {pets.length > 0 && (
                    <div className="bg-white border border-orange-200 rounded-xl p-4 sm:p-5 mt-5 shadow-sm">
                      <button
                        onClick={() => setIsPetListOpen(!isPetListOpen)}
                        className="flex items-center justify-between w-full text-left"
                      >
                        <div className="flex items-center gap-3">
                          <span>🐾</span>
                          <h3 className="text-sm sm:text-base font-semibold text-[#000048]">
                            Added Pets
                          </h3>
                        </div>

                        <FaChevronDown
                          className={`text-[#000048] w-5 h-5 transition-transform duration-300 ${
                            isPetListOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                      {isPetListOpen && (
                      <div className="space-y-3  mt-3 ">
                        {pets.map((pet) => (
                          <div
                            key={pet._id}
                            className="flex justify-between items-start gap-3 p-3 bg-orange-50 border border-orange-100 rounded-lg shadow-sm"
                          >
                            <div className="min-w-0 flex-1">
                              <p className="text-base font-semibold text-[#000048] break-words">
                                {pet.name || "Unnamed Pet"}
                              </p>
                              <p className="text-sm text-gray-700 break-words">
                                {[
                                  getPetTypeName(pet.pet_type),
                                  pet.breed && getBreedName(pet.breed),
                                  pet.size && getSizeLabel(pet.size),
                                  pet.gender || "Unknown",
                                ]
                                  .filter(Boolean)
                                  .join(" • ")}
                              </p>
                            </div>

                            <button
                              onClick={() => {
                                setEditingPet(pet);
                                setDrawerOpen(true);
                              }}
                              className="flex-shrink-0 text-sm text-orange-600 hover:text-orange-800 font-medium"
                            >
                              Edit
                            </button>
                          </div>
                        ))}
                      </div>
                       )}
                    </div>
                  )}

                  <button
                    onClick={handleAddPet}
                    className="py-3 px-5 w-full bg-gradient-to-r from-[#FF9933] to-[#FF6600] text-white rounded-xl font-semibold text-base sm:text-lg hover:from-[#FF6600] hover:to-[#FF3300]"
                  >
                    + Add Pet
                  </button>
                </div>
              </>
            )}
         </div>                  

          {showPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Price Change
                </h3>
                <p className="text-gray-600 mb-5">{popupMessage}</p>

                <div className="flex justify-center gap-4">
                  <button
                    onClick={confirmPriceUpdate}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                  >
                    OK
                  </button>
                  <button
                    onClick={cancelPriceUpdate}
                    className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
           
          {/* RIGHT SIDE (Cart Section) */}
          <div className="w-full lg:w-[65%] space-y-3 sm:space-y-4 lg:space-y-6">
            {hasCartItems ? (
              cartItems.map((item, index) => {
                const totalPrice = getItemTotal(item);
                const itemKey = getItemKey(item);

                const itemDiscount = getItemDiscount(item);
                console.log("items in cart", item);
                // const singlePet = pets[0];
                //const isCompatible = isPetAllowedForThisService(singlePet, item);
                const selectedPet =
                  pets.find((p) => p._id === item.vendor_pet_id)
                   //||(pets.length === 1 ? pets[0] : null);

               // const isCompatible =
                  //selectedPet && isPetAllowedForThisService(selectedPet, item);
                const isCompatible =
                  selectedPet && isPetFullyCompatible(selectedPet, item);

                  const options = pets
                    .filter((pet) => isPetFullyCompatible(pet, item))
                    .map((pet) => ({
                      value: pet._id,
                      label: `${pet.name?.toUpperCase()} (${[
                        getPetTypeName(pet.pet_type),
                        pet.breed && getBreedName(pet.breed),
                        pet.size && getSizeLabel(pet.size),
                      ]
                        .filter(Boolean)
                        .join(" • ")})`
                    }));

                  const selectedOption =
                    options.find(opt => opt.value === item.vendor_pet_id) || null;

                  return (
                  <div
                    key={item._id || index}
                    className="relative bg-white rounded-2xl shadow-md p-2 sm:p-2 lg:p-6 border border-gray-100 hover:shadow-lg transition-shadow duration-300 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3"
                  >
                    <div className="flex-1 min-w-0 space-y-2">
                      {item.start_date && (
                        <p className="flex flex-wrap items-center text-sm font-medium text-gray-700 gap-y-2">
                          <FaCalendarAlt className="text-orange-500 mr-2" />
                          <span className="bg-orange-50 text-orange-800 px-3 py-1 rounded-full font-semibold shadow-sm mr-2">
                            {formatDate(item.start_date)}
                          </span>

                          {item.end_date && (
                            <>
                              <span className="mx-1 text-orange-500 font-semibold">
                                →
                              </span>
                              <span className="bg-orange-50 text-orange-800 px-3 py-1 rounded-full font-semibold shadow-sm ml-2">
                                {formatDate(item.end_date)}
                              </span>
                            </>
                          )}
                        </p>
                      )}

                      <h4 className="text-sm sm:text-base font-semibold leading-snug text-gray-900 break-words pr-6">
                        {item.name || item.description}
                        <span className="block sm:inline text-orange-800 text-sm">
                          {" "}
                          (
                          {item.service_type
                            ? item.service_type
                            : formatServiceType(item.item_type)}
                          )
                        </span>
                      </h4>

                      {/* Pet Selection */}
                      <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 mb-2">
                        <label className="text-base text-gray-600 font-medium ">
                          🐾 <span className="ml-2">Pet:</span>
                        </label>

                        <div className="w-full ">

                        {!userPhone ? (
                          <div className=" bg-orange-50 text-orange-800 px-3 py-1.5 rounded-lg border border-orange-200 font-medium text-sm leading-snug break-words capitalize">
                            {[
                              item.pet_type_name || item.pet_type?.name,
                              item.petSize?.size_label,
                              item.petBreed || item.breed_name
                            ]
                              .filter(Boolean) 
                              .join(" • ")}
                          </div>
                        ) : pets.length === 0 ? (
                        <>
                            <div className=" bg-orange-50 text-orange-800 px-4 py-1.5 rounded-lg border border-orange-200 whitespace-nowrap font-semibold text-sm leading-snug break-words capitalize">
                            {[
                              getPetTypeName(item.pet_type),
                            item?.petSize && getSizeLabel(item.petSize),
                              item?.petBreed &&getBreedName(item.petBreed)
                            ]
                              .filter(Boolean)
                              .join(" • ")}
                          </div>

                          <button
                            //onClick={handleAddPet}
                           // onClick={() => handleAddPet(item)}
                              onClick={() =>   handleAddPetDetail(item,index)}    
                            className="px-3 py-1.5 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors"
                          >
                            + Add Pet Details
                          </button>
                          </>
                        ) : pets.length === 1 ? (
                          (() => {
                            const singlePet = pets[0];
                            const isCompatible = isPetFullyCompatible(singlePet, item);
                            
                            // If this service already has this pet assigned
                            if (item.vendor_pet_id === singlePet._id) {
                              return (
                                <div className="w-full sm:w-auto text-gray-800 font-medium bg-orange-50 px-3 py-2 rounded-lg border border-orange-200 break-words">
                                  {singlePet.name} ({[
                                    getPetTypeName(singlePet.pet_type),
                                    singlePet.size && getSizeLabel(singlePet.size),
                                    singlePet.breed && getBreedName(singlePet.breed)
                                  ].filter(Boolean).join(" • ")})
                                </div>
                              );
                            }
                            
                            // If no pet assigned, show dropdown with existing pet + add button
                            if (!item.vendor_pet_id) {
                              return (
                                <div className="flex flex-col sm:flex-row w-full gap-2 ">
                                  <select
                                    className=" w-full sm:w-auto border border-gray-300 rounded-lg px-3 py-2 text-base font-medium"
                                    value=""
                                    onChange={(e) => e.target.value && handlePetSelect(e.target.value, index)}
                                  >
                                    <option value="">Select Pet</option>
                                    {pets.filter(p => isPetFullyCompatible(p, item)).map(pet => (
                                      <option key={pet._id} value={pet._id}>
                                        {pet.name} ({getPetTypeName(pet.pet_type)} • {getSizeLabel(pet.size)})
                                      </option>
                                    ))}
                                  </select>
                                  <button
                                    onClick={() => handleAddPetDetail(item, index)}
                                    className="px-3 py-2 text-xs whitespace-nowrap flex-shrink-0 bg-orange-500 text-white rounded-lg font-medium"
                                  >
                                    + New Pet
                                  </button>
                                </div>
                              );
                            }
                            
                            return null;
                          })()
                        ) : (
                           
                          <div className="flex flex-col sm:flex-row w-full gap-4  ">
                          {/* <select
                            className="w-full sm:w-auto sm:min-w-[220px] border border-gray-300 rounded-lg px-3 py-2 text-sm font-medium focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition"
                            value={item.vendor_pet_id || ""}
                            onChange={(e) =>
                              handlePetSelect(e.target.value, index)
                            }
                          >
                            <option value="">Select Pet</option>

                            {/* ── pet with available size anf type are selectable ── */}
                            {/* {pets
                              .filter((pet) => isPetFullyCompatible(pet, item)) // ← NEW: type + size check
                              .map((pet) => (
                                <option key={pet._id} value={pet._id}>
                                  {pet.name?.toUpperCase()}  
                                  <span className="text-grey-500">
                                    (
                                    {[
                                      getPetTypeName(pet.pet_type),
                                      pet.breed && getBreedName(pet.breed),
                                      pet.size && getSizeLabel(pet.size),
                                    ]
                                      .filter(Boolean)
                                      .join(" • ")}
                                    )
                                  </span>
                                </option>
                              ))}

                            {/* Keep this nice message */}
                            {/* {pets.filter((pet) =>
                              isPetFullyCompatible(pet, item),
                            ).length === 0 && (
                              <option value="" disabled>
                                No compatible pet type or size available for
                                this service
                              </option>
                            )}
                          </select>*/}

                          <Select
                            className="w-full "
                            options={options}
                            value={selectedOption}   // ✅ FIXED

                            onChange={(option) =>
                              handlePetSelect(option?.value, index)
                            }

                            placeholder="Select Pet"
                            isSearchable={false}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                              
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: "42px",
                              width: "100%",
                              fontSize: "16px",
                              borderRadius: "10px",
                              display: "flex",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                              fontSize: "15px",
                            }),
                            option: (base, state) => ({
                              ...base,
                              fontSize: "15px",
                              padding: "10px 12px",
                              backgroundColor: state.isSelected
                                ? "#f1f0ef"
                                : state.isFocused
                                ? "hsl(33, 100%, 97%)"
                                : "white",
                              color: "#374151",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: "#111827",
                            }),
                          }}  
                          />
                         {/* Only show + New Pet button if no pet assigned to this service */}
                            {!item.vendor_pet_id && (
                              <button
                                onClick={() => handleAddPetDetail(item, index)}
                                className="w-full sm:w-auto px-3 py-2 text-base sm:text-base  whitespace-nowrap flex-shrink-0 bg-orange-500 text-white rounded-lg font-medium"
                              >
                                + New Pet
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                      </div>

                      {cartErrors[index] && (
                        <p className="text-sm text-red-600">
                          {cartErrors[index]}
                        </p>
                      )}

                      {isBoardingItem(item) && (
                        <p className="text-sm text-gray-700 flex items-center gap-2">
                          <span className="text-lg" aria-hidden="true">
                            🏠
                          </span>
                          {item.room_name || item.room_type_name || "Room"}
                        </p>
                      )}

                      {item.duration && (
                        <p className="flex items-center text-gray-700 text-sm">
                          <FaHourglassHalf className="text-orange-500 mr-2" />
                          Duration:&nbsp;
                          {(() => {
                            const type = (
                              item.item_type ||
                              item.service_type ||
                              ""
                            ).toLowerCase();

                            if (type.includes("grooming")) {
                              return `${item.duration} `;
                            }

                            if (type.includes("day")) {
                              // Matches "day care", "day_care", "daycare"
                              return `${item.duration}`;
                            }
                            if (
                              type.includes("vet") ||
                              type.includes("clinic")
                            ) {
                              return `${item.duration} min`;
                            }

                            // Default for Boarding or others
                            return `${item.duration} day${item.duration > 1 ? "s" : ""}`;
                          })()}
                        </p>
                      )}

                      {/* Notes per service item */}
                      {userPhone && (
                      <div className="mt-2">
                      <label className="text-sm text-gray-600 font-medium flex items-center gap-1">
                        📝 <span>Notes <span className="text-gray-400 text-xs">(optional)</span></span>
                      </label>
                      <textarea
                        rows={2}
                        placeholder="Any special instructions for this service..."
                        className="w-full mt-1 px-3 py-2 text-sm border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none bg-white placeholder-gray-400"
                        value={item.notes || ""}
                        onChange={(e) => {
                          const updatedCart = cartItems.map((ci, i) =>
                            i === index
                              ? { ...ci, notes: e.target.value }
                              : ci
                          );
                          setCartItems(updatedCart);
                          sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
                        }}
                      />
                    </div>
                  )}

                      {(item.item_type?.toLowerCase().includes("day_care") ||
                        item.item_type
                          ?.toLowerCase()
                          .includes("dog_walking")) &&
                        item.frequency && (
                          <p className="text-sm flex items-center mt-1">
                            <TbRepeat className="text-blue-500 mr-2 text-base font-bold " />
                            Frequency :{" "}
                            {item.frequency
                              .split("_")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")}
                          </p>
                        )}
                    </div>

                    <div className="flex-shrink-0 text-left sm:text-right mt-0 mb-1">
                      <div className="flex w-full justify-end mb-1">
                      <button
                        onClick={() => setDeleteItemId(item.cartItemId || item._id)}
                        className="text-blue-500 hover:text-red-700  ml-auto "
                      >
                        <FaTrash size={16} />
                      </button>
                    </div>
                      {/* 1. Slashed Price Logic */}
                      {getItemDiscount(item) > 0 ? (
                        <div className="flex flex-col items-end gap-1">
                      {/* Slashed price with Save tooltip on same line */}                
                        <div className="flex items-center gap-1">
                          <span className=" text-xs sm:text-sm font-bold text-[#15803d] bg-green-50 px-2 py-0.5 rounded border border-green-500">
                            Save ₹{getItemDiscount(item)}
                          </span>
                          <Tooltip discounts={getItemDiscountInfo(item)} />

                        <div className="flex flex-col items-start sm:items-end">
                          <span className=" text-lg sm:text-xl font-bold text-orange-500 line-through decoration-grey-400 decoration-1">
                            ₹{item.unit_price || item.price}
                          </span>
                        </div>
                        </div>
                          <span className="text-lg sm:text-xl font-extrabold text-[#000048]">
                            ₹
                            {(item.unit_price || item.price) -
                              getItemDiscount(item)}
                          </span>
                        </div>
                         
                      ) : (
                        <span className="text-2xl sm:text-xs font-extrabold text-[#000048]">
                          ₹{item.unit_price || item.price}
                        </span>
                      )}
                      {/* 2. Save Discount (Green) */}
                    {/*  {getItemDiscount(item) > 0 && (
                        <div className="flex items-center gap-1 mt-1">
                      {getItemDiscount(item) > 0 && (
                        <div className="flex items-center gap-1 mt-1 justify-start sm:justify-end">
                          <span className="text-sm font-bold text-[#15803d] bg-green-50 px-2 py-0.5 rounded border border-green-100">
                            Save ₹{getItemDiscount(item)}
                          </span>
                          <Tooltip discounts={getItemDiscountInfo(item)} />
                        </div>
                      )}*/}

                      {/* 3. GST / Taxes (Red, Italic) */}
                      {getDisplayTax(item) > 0 && (
                        <p className="text-xs text-red-500 italic mt-1 text-right ml-auto">
                          + ₹{getDisplayTax(item).toFixed(2)} taxes and charges
                        </p>
                      )}
                    </div>
                   </div>
                );
              })
            ) : (
              <div className="flex flex-col items-center justify-center text-center py-6">
                <p className="text-gray-700 font-medium mb-3">
                  No services added yet.
                </p>
                <button
                  onClick={() => navigate("/shop-detail")}
                  className="px-5 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors shadow-sm"
                >
                  Browse Services
                </button>
              </div>
            )}

            {hasCartItems && (
              <div className="bg-white p-3 sm:p-6 rounded-2xl border border-orange-200 shadow-md space-y-2">
                <div className="flex justify-between text-gray-700 font-medium">
                  <span>Sub total</span>
                  {/*<span>₹{subtotal.toFixed(2)}</span>*/}
                  <span><span>₹{(subtotal - totalDiscount).toFixed(2)}</span></span>
                </div>

                {/* Additional Discount Section */}
               {/* {orderDiscountData && orderDiscountData.discount_amount > 0 && (
                  <>
                    <div className="flex justify-between items-center text-green-600">
                      <span>
                        Additional Discount
                        <Tooltip discounts={[{
                          name: "Order Discount",
                          type: orderDiscountData.discount_type,
                          value: orderDiscountData.discount_value,
                          discount_amount: orderDiscountData.discount_amount,
                          is_active: 1
                        }]} />
                      </span>
                      <span>- ₹{orderDiscountData.discount_amount.toFixed(2)}</span>
                    </div>
                    
                    {/* Net Amount */}
                 {/* <div className="flex justify-between items-center pt-2">
                    <span className="text-gray-800 font-semibold">Net Amount</span>
                    <div className="text-right">
                      <span className="text-gray-500 line-through text-sm mr-2">
                        ₹{(subtotal - totalDiscount).toFixed(2)}
                      </span>
                      <span className="text-gray-800 font-bold">
                        ₹{orderDiscountData.amount_after_discount.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </>
              )}
              {/* Tax Amount */}
              {/* <div className="flex justify-between items-center">
               <span className="text-red-600 font-medium">Tax Amount</span>
                <div className="text-right">
                  {orderDiscountData?.discount_amount > 0 ? (
                    <>
                      <span className="text-gray-500 line-through text-sm mr-2">
                        ₹{totalGST.toFixed(2)}
                      </span>
                      <span className="text-red-600 font-semibold">
                        + ₹{orderDiscountData.tax_amount_after_discount.toFixed(2)}
                      </span> 
                    </>
                  ) : ( 
                    <span className="text-red-600 font-semibold">
                      + ₹{totalGST.toFixed(2)}
                    </span>
                  )}
                </div>
              </div> */}             
              {/* Order Amount */}
             {/* <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                <span className="text-lg font-bold text-orange-600">Order Amount</span>
                <span className="text-lg font-bold text-orange-600">
                  ₹{calculateFinalTotal()}
                </span>
              </div> */}
              {/* {totalDiscount > 0 && (
                  <div className="flex justify-between text-green-600">
                    <span>Discount</span>
                    <span>- ₹{totalDiscount.toFixed(2)}</span>
                  </div>
              )} */}
                <div className="flex justify-between text-red-700 font-medium">
                  <span>Taxes and Fee</span>
                  <span>+ ₹{totalGST.toFixed(2)}</span>
                </div>
                <div className="flex justify-between gap-4 text-base sm:text-lg font-bold text-orange-600">
                  <span>Total Amount</span>
                  <span>₹{total.toFixed(0)}</span>
                </div>
                <button
                  onClick={
                    userPhone ? handleProceedToPayment : handleLoginClick
                  }
                   disabled={userPhone && hasMissingPetAssignment()}
                  className={`w-full py-3 px-5 mt-4 rounded-xl font-semibold text-base sm:text-lg shadow-lg transition-all duration-300 transform hover:scale-[1.02]
                    ${
                      !userPhone
                        ? "bg-[#000048] text-white"
                        : userPhone && hasMissingPetAssignment()
                        ? "bg-orange-300 text-white cursor-not-allowed hover:scale-100 opacity-60"
                        : "bg-gradient-to-r from-[#FF9933] to-[#FF6600] text-white hover:from-[#FF6600] hover:to-[#FF3300]"
                    }`}
                >
                  {userPhone ? (
                    <span className="flex items-center justify-center gap-2">
                      Proceed to Booking
                    </span>
                  ) : (
                    "Login to Proceed"
                  )}
                </button>

                {!userPhone && (
                  <p className="text-center text-xs text-gray-500 mt-2">
                    You will be able to complete payment after a quick login.
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      
      {/* ✅ ADD DELETE MODAL HERE (VERY IMPORTANT POSITION) */}
    {deleteItemId && (
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
        onClick={() => setDeleteItemId(null)}
      >
        <div
          className="bg-white w-[90%] max-w-sm rounded-2xl shadow-2xl p-6 text-center"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="text-red-500 text-4xl mb-3">🗑️</div>

          <h3 className="text-lg font-semibold mb-2">
            Remove Item?
          </h3>

          <p className="text-sm text-gray-600 mb-5">
            Are you sure you want to remove{" "}
            <span className="font-semibold text-black">
              "{itemToDelete?.name || itemToDelete?.service_type}"
            </span>{" "}
            from your cart?
          </p>

          {/* 👉 YOUR BLOCK GOES HERE */}
          <div className="flex gap-3">
            <button
              onClick={() => setDeleteItemId(null)}
              className="flex-1 py-2 rounded-lg border text-gray-600 hover:bg-gray-300"
            >
              Cancel
            </button>

            <button
              onClick={() => {
                removeFromCart(deleteItemId);
                setDeleteItemId(null);
              }}
              className="flex-1 py-2 rounded-lg bg-red-500 text-white hover:bg-orange-600"
            >
              Yes, Remove
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
     
    {isPhoneModelOpen && (
        <PhoneModel isOpen={isPhoneModelOpen} closeModal={closePhoneModel} />
      )}

      {/* Popups & Drawers */}
      {isPhoneModelOpen && <PhoneModel onClose={closePhoneModel} />}
      <PetDrawer
        isOpen={drawerOpen}
        onClose={handleCloseDrawer}
        petToEdit={editingPet}
       // guestPetData={user && guestPetData ? guestPetData : null} 
        guestPetData={selectedGuestPet}
         quickAddMode={quickAddMode} 
        onSave={handleSavePet}
      />

      <Customerdetaildrawer
        isOpen={isCustomerDrawerOpen}
        onClose={handleCloseCustomerDrawer}
        customerData={customerDetails}
        token={token}
        onUpdate={handleUpdateCustomer}
        phone={userPhone}
      />
      {/* Secondary User Edit Drawer */}
      <SecondaryUserDrawer
        isOpen={isSecondaryDrawerOpen}
        onClose={() => setIsSecondaryDrawerOpen(false)}
        userData={selectedSecondaryUser}
        token={token}
        onUpdate={handleUpdateSecondaryUser}
        onSendOTP={sendPhoneUpdateOTP}
      />

    </div>
  );
};

export default Confirm;
